export enum SmartMenuRegistrationField {
  Name = 'name',
  Phone = 'phone',
  Cpf = 'cpf',
  Email = 'email',
  Birthday = 'birthday',
  Gender = 'gender'
}
